import React, { useCallback, useEffect, useRef, useState } from "react";
import Radio from "./Radio";
import { inputStyles, inputStylesOtp } from "../utils/utilities";
import { verifiedSvg } from "../assets/svg";
import { useDispatch, useSelector } from "react-redux";
import {
    updatePhone,
    updateUHID,
    verifyOtp,
} from "../Redux/Reducers/appointmentFilterSlice";
import { getPatientData } from "../utils/api";
import { toast } from "react-toastify";
import CustomToast from "./CustomToast";
import { Zoom } from "react-toastify";

function VerificationSection({ setShowForm }) {
    const [selectedVerificationType, setSelectedVerificationType] =
        useState("phone");
    const [isOtpSent, setIsOtpSent] = useState(false);
    const { phone, uhid, isOtpVerified } = useSelector(
        (state) => state.appointment
    );

    const isMobile = window.innerWidth <= 768;

    const dispatch = useDispatch();
    const inputRefs = useRef([]);

    const [otp, setOtp] = useState(["", "", "", ""]);

    const handleVerify = async () => {
        if (isOtpSent === false) {
            const response = await getPatientData(phone || uhid, true);
            console.log(response, "response");

            if (response.statusCode === 200 && phone) {
                setIsOtpSent(true);
            } else if (response.statusCode === 200 && uhid) {
                dispatch(verifyOtp(true));
            } else {
                toast(
                    <CustomToast onClick={() => setShowForm("unregistered")} />,
                    {
                        transition: Zoom,
                        className: "custom-toast",
                        bodyClassName: "custom-toast-body",
                        progressClassName: "custom-toast-progress",
                    }
                );
            }
        }
    };

    const setInitialState = useCallback(() => {
        dispatch(updatePhone(""));
        dispatch(updateUHID(""));
        setIsOtpSent(false);
        setOtp(["", "", "", ""]);
        dispatch(verifyOtp(false));
    }, [dispatch]);

    useEffect(() => {
        setInitialState();
    }, [setInitialState]);

    const handleInputChange = (e, index) => {
        const value = e.target.value;
        const prevValueLength = otp[index].length;

        if (value.length <= 1 && !isNaN(value)) {
            const otpCopy = [...otp];
            otpCopy[index] = value;
            setOtp(otpCopy);

            // Move focus to the next input field only if a character is added
            if (value.length > prevValueLength && index < otp.length - 1) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    return (
        <div className="verification-container">
            <div>
                <div className="f600-16px">Mobile or UHID</div>
                <div className="mt-2 d-flex gap-4">
                    <Radio
                        label="Phone"
                        value="phone"
                        checked={selectedVerificationType === "phone"}
                        name="verification-type"
                        size={14}
                        textColor="rgba(102, 110, 125, 1)"
                        onChange={() => {
                            setSelectedVerificationType("phone");
                            setInitialState();
                        }}
                    />
                    <Radio
                        label="UHID"
                        value="uhid"
                        checked={selectedVerificationType === "uhid"}
                        name="verification-type"
                        size={14}
                        textColor="rgba(102, 110, 125, 1)"
                        onChange={() => {
                            setSelectedVerificationType("uhid");
                            setInitialState();
                        }}
                    />
                </div>
            </div>
            <div className="mt-4">
                <div>
                    <label className="f600-16px">
                        {selectedVerificationType === "phone"
                            ? "Verify Phone number"
                            : "Verify UHID"}
                    </label>
                    <div className={`mt-2 gap-2 gap-lg-3 d-flex`}>
                        <div className={isMobile ? 'col' : 'col-3'}>
                            <input
                                type="text"
                                placeholder={
                                    selectedVerificationType === "phone"
                                        ? "Enter your 10 digit mobile number"
                                        : "Enter your UHID"
                                }
                                style={inputStyles}
                                value={
                                    selectedVerificationType === "phone"
                                        ? phone
                                        : uhid
                                }
                                maxLength={
                                    selectedVerificationType === "phone"
                                        ? "10"
                                        : undefined
                                }
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (selectedVerificationType === "phone") {
                                        if (
                                            !isNaN(value) &&
                                            value.length <= 10
                                        ) {
                                            dispatch(updatePhone(value));
                                            setIsOtpSent(false);
                                        }
                                    } else {
                                        dispatch(updateUHID(value));
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        if (
                                            selectedVerificationType === "phone" &&
                                            phone &&
                                            phone.length === 10
                                        ) {
                                            handleVerify();
                                        } else if (
                                            selectedVerificationType === "uhid" &&
                                            uhid
                                        ) {
                                            handleVerify();
                                        } else if (
                                            selectedVerificationType === "phone" &&
                                            phone &&
                                            phone.length !== 10
                                        ) {
                                            toast("Please enter a valid phone number");
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div
                            className={`otp-button ${
                                (phone && phone.length === 10) || uhid
                                    ? "active-button"
                                    : ""
                            } `}
                            onClick={() => {
                                if (
                                    selectedVerificationType === "phone" &&
                                    phone &&
                                    phone.length === 10
                                ) {
                                    handleVerify();
                                } else if (
                                    selectedVerificationType === "uhid" &&
                                    uhid
                                ) {
                                    handleVerify();
                                } else if (
                                    selectedVerificationType === "phone" &&
                                    phone &&
                                    phone.length !== 10
                                ) {
                                    toast("Please enter a valid phone number");
                                }
                            }}
                        >
                            {selectedVerificationType === "phone" ? (
                                "Send OTP"
                            ) : isOtpVerified ? (
                                <>{verifiedSvg({})} &nbsp; Verified</>
                            ) : (
                                "Verify"
                            )}
                        </div>
                    </div>
                    {isOtpSent && (
                        <div className="otp-success f600-16px">
                            OTP has been sent !
                        </div>
                    )}
                </div>
            </div>
            {isOtpSent && (
                <div className="mt-4">
                    <div>
                        <label className="f600-16px">
                            {"Verify Phone number"}
                        </label>
                        <div className="mt-2 d-flex d-flex gap-2 gap-lg-3">
                            <div className={`d-flex justify-content-between ${isMobile ? "col" : "col-2"}`}>
                                {otp.map((item, index) => (
                          <input
                          key={index}
                          type={isMobile ? "tel" : "text"}
                          pattern="\d*" // Allow only digits
                          style={inputStylesOtp}
                          placeholder="0"
                          value={item}
                          ref={(el) => (inputRefs.current[index] = el)}
                          onChange={(e) => handleInputChange(e, index)}
                          onKeyDown={(e) => {
                              if (e.key === 'Backspace' && e.target.value === '') {
                                  const otpCopy = [...otp];
                                  if (index > 0) {
                                      otpCopy[index - 1] = '';
                                      setOtp(otpCopy);
                                      inputRefs.current[index - 1].focus();
                                  }
                              }
                          }}
                      />
                                ))}
                            </div>
                            <div
                                className={`otp-button ${
                                    !otp.includes("") ? "active-button" : ""
                                } `}
                                onClick={() => {
                                    if (otp.join("") === "1234") {
                                        dispatch(verifyOtp(true));
                                    } else {
                                        toast.error("Invalid OTP");
                                        setOtp(["", "", "", ""]);
                                    }
                                }}
                            >
                                {isOtpVerified ? (
                                    <>{verifiedSvg({})} &nbsp; Verified</>
                                ) : (
                                    "Verify"
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default VerificationSection;
